import { Button, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useMemo, useState } from "react";
import { commaSeparateNumber, hasPermission } from "../../../utils/functions";
import { CARTON_INVENTORY_CREATE_PERMISSION } from "../../../routes/permissions";
import ListTable from "common/ListTable";
import ItemAssignDrawer from "../ItemAssignDrawer";

const formatDimensions = (row) => {
  const parts = [row.length, row.width, row.height].filter((v) => v != null && v !== "");
  return parts.length ? parts.join("×") : "—";
};

const SupportingMaterialTable = ({ supportingMaterials = [], movement, disabled }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);

  const dataSource = useMemo(
    () =>
      (supportingMaterials || []).map((row) => ({
        ...row,
        key: row.id,
        material_type_name: row.material_type?.name || `Type #${row.material_type_id || "—"}`,
        ply_name: row.ply?.name || "—",
      })),
    [supportingMaterials],
  );

  const openDrawerForRow = (row) => {
    setActiveRow(row);
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setActiveRow(null);
  };

  const columns = [
    {
      title: "Material",
      dataIndex: "material_type_name",
      key: "material_type_name",
      width: 120,
      ellipsis: true,
    },
    {
      title: "Ply",
      dataIndex: "ply_name",
      key: "ply_name",
      width: 70,
      ellipsis: true,
    },
    {
      title: "Qty",
      dataIndex: "material_qty",
      key: "material_qty",
      width: 70,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "L×W×H",
      key: "dimensions",
      width: 80,
      render: (_, row) => formatDimensions(row),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
      width: 70,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "Total",
      dataIndex: "total_amount",
      key: "total_amount",
      width: 80,
      align: "right",
      render: (v) => (v != null ? commaSeparateNumber(v) : "—"),
    },
    {
      title: "Action",
      key: "action",
      width: 80,
      align: "center",
      fixed: "right",
      render: (_, row) => (
        <Button
          type="primary"
          size="small"
          icon={<PlusOutlined />}
          disabled={disabled || !movement || !hasPermission([CARTON_INVENTORY_CREATE_PERMISSION])}
          onClick={() => openDrawerForRow(row)}
        >
          Add
        </Button>
      ),
    },
  ];

  return (
    <Card title="Supporting Material" size="small" className="mt-3">
      <ListTable
        bordered
        size="small"
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        scroll={{ x: "max-content" }}
        locale={{ emptyText: "Select a supplier PO to load supporting materials" }}
      />
      <ItemAssignDrawer
        open={drawerOpen}
        onClose={closeDrawer}
        selectedRows={activeRow ? [activeRow] : []}
        movement={movement}
        tableType="supporting_material"
      />
    </Card>
  );
};

export default SupportingMaterialTable;
